import { render, staticRenderFns } from "./HotelQnaForm.vue?vue&type=template&id=7b1ae736&scoped=true&"
import script from "./HotelQnaForm.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HotelQnaForm.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HotelQnaForm.vue?vue&type=style&index=0&id=7b1ae736&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1ae736",
  null
  
)

export default component.exports